import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';

export default class DefaultUIListener extends UIListener {

    constructor() {
        super();
    }
}

ComponentManager.setUIListener('DefaultUIListener', DefaultUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');